module.exports = __webpack_public_path__ + "static/img/Foresite-Selected.a1d6c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Foresite-Selected.png
// module id = 745
// module chunks = 0